var generic = window.generic || {};
var site = window.site || {};

(function ($) {
  site.waitlistEmeaV1 = {
    templateContainer: $(),

    initWaitlistSignup: function () {
      var $emailContainerNodes = this.templateContainer;

      if (!$emailContainerNodes.length) {
        return null;
      }

      $emailContainerNodes.each(function () {
        var waitlistContainerNode = $(this);

        /* Close Button */
        waitlistContainerNode
          .find('.js-close-button')
          .unbind('click')
          .bind('click', function () {
            waitlistContainerNode.slideUp(600);

            return false;
          });
        /* Close Button */
        /* Show hide additional units */
        // Grab class name from hidden unit
        var classShowHide = document.getElementById('unit_class_reveal').value;

        // hide the unit to begin with, if it exists
        if (classShowHide.length > 0) {
          $('.' + classShowHide).hide();
        }
        // $('.' + classShowHide).css({"position":"fixed","left":"-9999999"});
        /* Submit Form */
        var waitlistFormNode = waitlistContainerNode.find('form'),
          waitlistSubmitNode = waitlistContainerNode.find("input[type='submit']"),
          waitlistProgressNode = waitlistContainerNode.find('div.progress'),
          waitlistSuccessNode = waitlistContainerNode.find('div.success'),
          waitlistErrorNode = waitlistContainerNode.find('div.error'),
          waitlistInputNode = waitlistContainerNode.find('input.waitlist_signup'),
          waitlistSubmissionOption = waitlistContainerNode.find("input[name='redirect_or_text']"),
          waitlistRedirectURL = waitlistContainerNode.find("input[name='redirect']"),
          waitlistSignupText = waitlistContainerNode.find('div.waitlist__signup_text'),
          waitlistSignupFields = waitlistContainerNode.find('div.waitlist__signup_fields'),
          emailOptStatusNode = $('#address-info-newsletter'),
          ageInputNodes = $("select[id^='form--profile_preferences--field--BIRTH']");

        // if the user is logged in,the fields are populated..
        if (site && site.userInfoCookie) {
          if (site.userInfoCookie.getValue('signed_in') === '1') {
            $("[id='waitlist_signup--field--FIRST_NAME']").val(
              site.userInfoCookie.getValue('first_name')
            );
            $("[id='waitlist_signup--field--LAST_NAME']").val(
              site.userInfoCookie.getValue('last_name')
            );
            $("[id='waitlist_signup--field--PC_EMAIL_ADDRESS']").val(
              site.userInfoCookie.getValue('email')
            );
            if (site.userInfoCookie.getValue('pc_email_optin') === '1') {
              $("[name='PC_EMAIL_PROMOTIONS']").attr('checked', 'checked');
            }
          }
        }

        waitlistFormNode
          .not('.js-email-form-processed')
          .addClass('js-email-form-processed')
          .unbind('submit')
          .bind('submit', function (submitEvt) {
            submitEvt.preventDefault();
            waitlistSubmitNode.prop('disabled', true);
            waitlistProgressNode.removeClass('progress__invisible');

            waitlistInputNode.each(function () {
              const trimmedValue = $(this).val().trim();

              $(this).val('');
              if (trimmedValue) {
                $(this).val(trimmedValue);
              }
            });

            // retrieve form data in querystring format
            var formSerial = waitlistFormNode.serialize();
            // transform string into array of form elements
            var paramArr = formSerial.split('&'),
              paramStr = '';

            // Iterate through collection to transform form name/value into key/value properties of a literal object string.
            $.each(paramArr, function () {
              paramStr += '"' + this.split('=')[0] + '":"' + this.split('=')[1] + '",';
            });

            // Parse the string and create the literal object
            var params = JSON.parse('{' + paramStr.substring(0, paramStr.length - 1).replace('undefined', '') + '}');

            // These two fields contains special chars
            if (params['_TOKEN']) {
              params['_TOKEN'] = decodeURIComponent(params['_TOKEN']);
            }
            if (params['PC_EMAIL_ADDRESS']) {
              params['PC_EMAIL_ADDRESS'] = decodeURIComponent(params['PC_EMAIL_ADDRESS']);
            }

            // Remove the 2 hidden inputs we're using to handle the redirect
            params.redirect = undefined;
            params.redirect_or_text = undefined;

            // Send the data via a json rpc call
            generic.jsonrpc.fetch({
              method: 'rpc.form',
              params: [params],
              onSuccess: function () {
                if (
                  waitlistSubmissionOption.val() === 'redirect' &&
                  waitlistRedirectURL.val().length > 0
                ) {
                  // Redirect the current page to another
                  var dest = waitlistRedirectURL.val();

                  if (/^\/.+$/.test(dest)) {
                    dest = dest.replace(/^(\s|\/)+/, '');
                  }
                  if (/^(?!http|\/).+$/.test(dest)) {
                    dest = Drupal.settings.basePath + dest;
                  }
                  window.location.href = dest;

                  return false;
                } else {
                  // Show success messages within this template
                  waitlistProgressNode.addClass('hidden');
                  waitlistSuccessNode.removeClass('hidden');
                  waitlistErrorNode.addClass('hidden');
                  waitlistFormNode.addClass('hidden');
                  emailOptStatusNode.addClass('hidden');
                  waitlistSignupText.addClass('hidden');
                  waitlistSignupFields.addClass('hidden');
                  waitlistContainerNode.addClass('email_success');
                  $('html,body').animate(
                    {
                      scrollTop: $('.success').offset().top - 130
                    },
                    1000
                  );
                  // check to see if we have a class name
                  if (classShowHide.length > 0) {
                    $('.' + classShowHide).css('visibility', 'hidden');
                    $('.' + classShowHide).show();
                    // This is required as hidden slider blocks compute on document ready with width 0
                    // so we need to refresh the block to display properly and we dont want the user watching all this
                    // so we hide it whilst it is all happening
                    $('.slick-slider').slick('setOption', 'refresh', true, true);
                    $('.' + classShowHide).css('visibility', 'visible');
                  }
                  // tagging
                  $(document).trigger('waitlist:success', [
                    waitlistContainerNode.find("input[name='EVENT_ID']")
                  ]);
                }
              },
              onFailure: function (jsonRpcResponse) {
                // Add the error messages below the header
                var errorObjectsArray = jsonRpcResponse.getMessages();
                // generic.showErrors(errorObjectsArray);

                waitlistErrorNode.html('');
                ageInputNodes.removeClass('error');
                waitlistInputNode.removeClass('error');
                var $errors = $('.waitlist__errors');
                var birthFieldsRegex = new RegExp('birth_\\w+', 'i');
                var nameFieldsRegex = new RegExp('PC_EMAIL_ADDRESS|(?:FIRST|LAST)_NAME', 'i');

                errorObjectsArray.forEach(function (e) {
                  // for birthday input fields (i.e birthday,birthmonth,birthyear).
                  if (birthFieldsRegex.test(e.key)) {
                    const matches = e.key.match(birthFieldsRegex);
                    const str = matches[0];

                    // always 1 match per field,so select first match
                    $(
                      "[id='form--profile_preferences--field--" + str.toUpperCase() + "']"
                    ).addClass('error');
                    $("[id*='" + str + "'][class='error error-block']").addClass('error');
                    $("[id*='" + str + "'][class='error error-block']").text(e.text);
                  }
                  // for name,last_name,email input fields.
                  if (nameFieldsRegex.test(e.key)) {
                    const matches = e.key.match(nameFieldsRegex);
                    const str = matches[0];

                    // always 1 match per field,so select first match
                    $("[id='waitlist_signup--field--" + str.toUpperCase() + "']").addClass('error');
                    $("[id*='" + str + "'][class='error error-block']").addClass('error');
                    $("[id*='" + str + "'][class='error error-block']").text(e.text);
                  }

                  if (!birthFieldsRegex.test(e.key) && !nameFieldsRegex.test(e.key)) {
                    $errors.append('<div class="error">' + e.text + '</div>');
                    $errors.removeClass('hidden');
                  }
                });
                waitlistErrorNode.removeClass('hidden');
                // Show error messages in this template
                // waitlistErrorNode.html(errorObjectsArray[0].text).removeClass('hidden');
                waitlistProgressNode.addClass('progress__invisible');
                // just in case
                if (classShowHide.length > 0) {
                  $('.' + classShowHide).hide();
                }
                waitlistSubmitNode.prop('disabled', false);
                waitlistContainerNode.removeClass('email_success');
                // tagging
                $(document).trigger('waitlist:failure', [
                  waitlistContainerNode.find("input[name='EVENT_ID']")
                ]);
              }
            });
          });
        /* Submit Form */
      });
    }
  };

  Drupal.behaviors.waitlistEmeaSignup = {
    attach: function (context) {
      site.waitlistEmeaV1.templateContainer = $('.waitlist', context);
      site.waitlistEmeaV1.initWaitlistSignup();
    }
  };

  Drupal.behaviors.waitlistEmeaSelectBox = {
    toggleOptions: function ($newSelect) {
      if (!$newSelect.hasClass('js-select-box-disabled')) {
        $newSelect.children('.js-select-box-options').toggleClass('open');
        $newSelect.children('.js-select-box-label').toggleClass('open');
      }
    },
    setLabel: function ($oldSelect) {
      var selectedText =
        $oldSelect.children('option:selected').text() ||
        $oldSelect.children('option').first().text();
      var $newSelect = $oldSelect.data('new-select-box-reference');

      if (!!$newSelect) {
        $newSelect.children('.js-select-box-label').text(selectedText);
      }
    }
  };
})(jQuery);

function populateSelect(target, min, max) {
  if (!target) {
    return false;
  } else {
    min = min || 0;
    max = max || min + 100;

    var select = document.getElementById(target);

    for (var i = min; i <= max; i++) {
      var opt = document.createElement('option');

      opt.value = i;
      opt.innerHTML = i;
      select.appendChild(opt);
    }
  }
}

$(document).ready(function () {
  var $infoLink = $('.js-info-link-gdpr');

  populateSelect('form--profile_preferences--field--BIRTH_DAY', 1, 31);
  populateSelect('form--profile_preferences--field--BIRTH_MONTH', 1, 12);
  populateSelect('form--profile_preferences--field--BIRTH_YEAR', 1901, 2010);
  $('#terms_trigger').click(function () {
    $('#terms_details').toggle();
    $('#terms_arrow_1').toggle();
    $('#terms_arrow_2').toggle();
  });
  $('#terms_anchor_trigger').click(function () {
    $('#terms_details').toggle();
    $('#terms_arrow_1').toggle();
    $('#terms_arrow_2').toggle();
  });
  $infoLink.on('click', function () {
    if (!$('body').hasClass('device-pc') || navigator.userAgent.match(/iPad/)) {
      setTimeout(function () {
        var $gdprInfoPopup = $('.info-msg-gdpr');
        var $gdprInfoPopupArrow = $('.info-msg-gdpr__arrow');
        var gdprInfoLinkHeight = $infoLink.height();
        var popupArrowHeight = $gdprInfoPopupArrow.outerHeight(true);
        var posY = $infoLink.offset().top;
        var infoLinkTop = posY + gdprInfoLinkHeight + popupArrowHeight;

        $gdprInfoPopup.css({
          left: '50%',
          top: infoLinkTop + 'px',
          'margin-left': -$gdprInfoPopup.outerWidth() / 2
        });
        $gdprInfoPopupArrow.css({
          left: $gdprInfoPopup.width() / 2 + 'px'
        });
      }, 0);
    }
  });
});
